module.exports = __webpack_public_path__ + "img/study_2.26dcffa4.png";